import React, { Component } from 'react';
import CalloutButton from './CalloutButton';
import MultiResolutionImage from './MultiResolutionImage';

class Hero extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageToUse:
        typeof window === 'undefined'
          ? this.props.image
          : window.innerWidth >= 768 ? this.props.image : this.props.mobileImage
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (!this.props.mobileImage) return;
    this.setState({
      ...this.state,
      imageToUse:
        typeof window === 'undefined'
          ? this.props.image
          : window.innerWidth >= 768 ? this.props.image : this.props.mobileImage
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.imageToUse !== this.state.imageToUse;
  }

  renderHeroBody = ({
    tagline,
    taglineColour,
    hasCallout,
    calloutButtonLink,
    calloutButtonLabel,
    orientation,
    blurb,
    extendedMobile
  }) => {
    if (tagline || hasCallout) {
      return (
        <div className="hero-body">
          <div className="container">
            <div
              className={`columns is-mobile is-multiline${
                orientation !== 'left' ? ' is-centered' : ''
              }`}
            >
              <div
                className={this.getHeroBodyClassName({
                  orientation,
                  extendedMobile
                })}
              >
                <h1
                  className="title has-text-weight-semibold"
                  style={{
                    color: taglineColour ? taglineColour.hex : `#020202`
                  }}
                >
                  {tagline}
                </h1>
                {this.renderHeroBlurb({ blurb, orientation })}
                {this.renderHeroCallout({
                  hasCallout,
                  calloutButtonLink,
                  calloutButtonLabel
                })}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  renderHeroBlurb = ({ blurb, orientation }) => {
    if (blurb && blurb !== '') {
      return <p className="has-text-weight-bold">{blurb}</p>;
    }
    return null;
  };

  getHeroBodyClassName = ({ orientation, extendedMobile }) => {
    switch (orientation) {
      case 'home':
        return 'column is-12-mobile is-6-tablet is-offset-6-tablet';
        break;
      case 'left':
        return 'column is-12-mobile is-8-tablet is-5-desktop';
        break;

      case 'right':
        if (extendedMobile) {
          return 'column is-12-mobile is-5-tablet is-offset-5-tablet';
        }
        return 'column is-12-mobile is-6-tablet is-offset-7-tablet';
        break;
    }
  };

  renderHeroCallout = ({
    hasCallout,
    calloutButtonLink,
    calloutButtonLabel
  }) => {
    if (hasCallout) {
      return (
        <CalloutButton label={calloutButtonLabel} link={calloutButtonLink} />
      );
    }
    return null;
  };

  render() {
    const {
      isInCarousel = false,
      image = null,
      mobileImage = null,
      isFull = false,
      isLarge = false,
      tagline,
      taglineColour,
      calloutButtonLink,
      calloutButtonLabel,
      orientation,
      blurb,
      extendedMobile,
      showCalloutButton,
      backgroundAlignment
    } = this.props;
    const hasCallout = showCalloutButton;
    const { imageToUse } = this.state;
    let bgAlign = 'is-bottom-center';
    if (backgroundAlignment) {
      switch (backgroundAlignment) {
        case 'top left':
          bgAlign = 'is-top-left';
          break;
        case 'top right':
          bgAlign = 'is-top-right';
          break;
        case 'top center':
          bgAlign = 'is-top-center';
          break;
        case 'bottom left':
          bgAlign = 'is-bottom-left';
          break;
        case 'bottom right':
          bgAlign = 'is-bottom-right';
          break;
      }
    }

    if (isInCarousel) {
      return (
        <div
          className={`hero is-in-carousel is-orientation-${orientation}${
            isFull ? ' is-fullheight ' : ''
          }${isLarge ? ' is-large ' : ''} ${bgAlign}`}
        >
          <MultiResolutionImage image={imageToUse} />
          {this.renderHeroBody({
            tagline,
            taglineColour,
            hasCallout,
            calloutButtonLink,
            calloutButtonLabel,
            orientation,
            blurb,
            extendedMobile
          })}
        </div>
      );
    }

    return (
      <section
        className={`hero is-orientation-${orientation}${
          isFull ? ' is-fullheight ' : ''
        }${isLarge ? ' is-large ' : ''}${
          extendedMobile ? ' is-extended-mobile ' : ''
        }`}
      >
        <MultiResolutionImage image={imageToUse} />
        {this.renderHeroBody({
          tagline,
          taglineColour,
          hasCallout,
          calloutButtonLink,
          calloutButtonLabel,
          orientation,
          blurb,
          extendedMobile
        })}
      </section>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js